import $axios, { AxiosInstance } from "axios";

import { authInterceptor } from "./interceptors";

export const attachApiAxiosConfig = (axios: AxiosInstance) => {
  axios.defaults.baseURL = process.env.REACT_APP_API_URL;
};

const openStreetMapURL = "https://nominatim.openstreetmap.org/";

/**
 * By pure I mean with no interceptors
 */
export const pureApiAxios = $axios.create();
attachApiAxiosConfig(pureApiAxios);

export const apiAxios = $axios.create();
attachApiAxiosConfig(apiAxios);

/** Open street map api axios */
export const osmAxios = $axios.create({
  baseURL: openStreetMapURL,
});

apiAxios.interceptors.request.use(authInterceptor);
